import BrandMark from '@ui/BrandMark'
import { useTranslation } from 'react-i18next'

// Cookie session is set on this app's origin; OAuth lands once and the JWT
// cookie serves the whole authenticated surface.
const Login = () => {
  const { t } = useTranslation()

  const onGoogle = () => {
    window.location.assign('/auth/google')
  }

  return (
    <main className="min-h-dvh bg-cream-bg grid place-items-center px-4 py-8">
      <div className="w-full max-w-[420px] bg-paper rounded-xl shadow-lg overflow-hidden">
        <div className="bg-green-900 text-white px-6 py-8 flex items-center gap-4">
          <BrandMark size="xl" className="bg-paper rounded-lg p-1" />
          <div className="leading-tight">
            <div className="font-display font-extrabold text-2xl tracking-tight">
              {t('brand.name')}
            </div>
            <div className="text-xs uppercase tracking-caps text-green-100/80">
              {t('brand.tagline')}
            </div>
          </div>
        </div>

        <div className="px-6 py-7 flex flex-col gap-5">
          <div>
            <h1 className="font-display font-bold text-2xl tracking-tight text-ink-900">
              {t('auth.login.title')}
            </h1>
            <p className="text-sm text-ink-500 mt-1">
              {t('auth.login.subtitle')}
            </p>
          </div>

          <button
            type="button"
            onClick={onGoogle}
            className="
              w-full inline-flex items-center justify-center gap-3
              bg-green-700 hover:bg-green-800 text-white
              font-semibold text-base rounded-lg
              px-4 py-3 min-h-[44px]
              transition-colors
            "
          >
            <GoogleMark />
            {t('auth.login.google')}
          </button>

          <p className="text-xs text-ink-500 text-center mt-2">
            {t('auth.login.footer')}
          </p>
        </div>
      </div>
    </main>
  )
}

const GoogleMark = () => (
  <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
    <path
      fill="#FFC107"
      d="M43.6 20.5H42V20H24v8h11.3C33.6 32.9 29.2 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34 6.1 29.3 4 24 4 13 4 4 13 4 24s9 20 20 20 20-9 20-20c0-1.2-.1-2.3-.4-3.5z"
    />
    <path
      fill="#FF3D00"
      d="M6.3 14.7l6.6 4.8C14.7 16 19 13 24 13c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34 7.1 29.3 5 24 5 16.3 5 9.7 9 6.3 14.7z"
    />
    <path
      fill="#4CAF50"
      d="M24 44c5.2 0 9.9-2 13.4-5.3l-6.2-5.2C29.2 35 26.7 36 24 36c-5.2 0-9.6-3.1-11.3-7.6l-6.6 5.1C9.6 39.9 16.2 44 24 44z"
    />
    <path
      fill="#1976D2"
      d="M43.6 20.5H42V20H24v8h11.3c-.8 2.3-2.3 4.3-4.2 5.5l6.2 5.2C41.4 35.2 44 30.1 44 24c0-1.2-.1-2.3-.4-3.5z"
    />
  </svg>
)

export default Login
